import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Do you handle matters outside Delhi?",
    a: "Yes. While LexSant is headquartered in New Delhi, we represent clients across India. Our practice is designed for national reach — we regularly handle matters in courts, tribunals, and forums across multiple states.",
  },
  {
    q: "Will I be working directly with a partner?",
    a: "Absolutely. LexSant is a partner-led firm. Every matter receives direct partner attention from initial consultation through resolution. We do not delegate your case to associates.",
  },
  {
    q: "What types of sports law matters do you handle?",
    a: "We advise on athlete contracts, sponsorship and endorsement agreements, image rights, sports governance, federation disputes, regulatory compliance, anti-doping matters, and player representation across multiple sports.",
  },
  {
    q: "How does LexSant handle tax disputes vs. tax advisory?",
    a: "Our taxation practice spans the full spectrum — from proactive tax structuring and compliance advisory to aggressive litigation before Income Tax Tribunals and higher courts. Unlike most firms, you never have to switch counsel when advisory escalates to litigation.",
  },
  {
    q: "What is the first step if I want to consult with LexSant?",
    a: "Simply fill out the consultation form on this page or call us directly. All enquiries are strictly confidential. We will respond within 24 hours to schedule an initial discussion at your convenience.",
  },
];

export default function FAQ() {
  return (
    <section data-testid="faq-section" className="py-24 md:py-32 bg-navy-base">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="mb-16 animate-on-scroll">
          <p className="text-sm tracking-[0.3em] uppercase text-gold font-body font-medium mb-4">
            Questions
          </p>
          <h2 className="font-heading text-4xl md:text-5xl tracking-tight text-white">
            Frequently Asked
          </h2>
          <div className="h-px w-16 bg-gold/40 mt-6" />
        </div>

        <Accordion type="single" collapsible className="animate-on-scroll">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={faq.q}
              value={`faq-${i}`}
              className="border-b border-gold/10"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="py-6 text-left font-heading text-lg md:text-xl text-white hover:text-gold hover:no-underline transition-colors [&>svg]:text-gold">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm md:text-base text-gray-400 font-body leading-relaxed pb-6">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
